import { XCircleSolidIcon } from '@glu/icons-react';
import { createUseStyles, withTheme } from '@glu/theming';
import PropTypes from 'prop-types';
import React from 'react';
import { AccessibilityText } from '@glu/utilities-react';
import locale from '@glu/locale';
import styles from './Badge.styles';
import './themeDefaults';

const useStyles = createUseStyles(styles);

const Badge = ({
  applySelection,
  disabled,
  index,
  option,
  selection,
  onClick
}) => {
  const classes = useStyles();

  const handleOnClick = (event) => {
    event.stopPropagation();
    applySelection(selection.filter(curr => curr.id !== option.id));
  };
  const handleOnKeyDown = (event) => {
    event.stopPropagation();
    if (event.key === 'Enter') {
      applySelection(selection.filter(curr => curr.id !== option.id));
    }
  };
  return (
    <span key={option.id} data-qa="input-value">
      <span
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(event) => {
          event.stopPropagation();
          if (event.key === 'Enter') {
            onClick();
          }
        }}
      >
        {option.name}
      </span>
      <span
        role="button"
        className={classes.badge}
        tabIndex={0}
        onClick={handleOnClick}
        onKeyDown={handleOnKeyDown}
        title={locale.get('clear')}
        disabled={disabled}
      >
        <AccessibilityText>Clear Selection</AccessibilityText>
        <XCircleSolidIcon className={classes.clear} />
        {index + 1 < selection.length && locale.get('badgeSeperator')}
      </span>
    </span>
  );
};

Badge.propTypes = {
  /** A single option objext. */
  option: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,

  /** Callback to apply the selection */
  applySelection: PropTypes.func.isRequired,

  /** The index of this badge in the list */
  index: PropTypes.number.isRequired,

  /** Object representing the state of the current selection */
  selection: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

  /** whether the badge is disabled or not */
  disabled: PropTypes.bool.isRequired,

  onClick: PropTypes.func.isRequired
};

export default withTheme(Badge);
